import { Head, Link } from "@inertiajs/react";

import { FinalCta } from "@/components/final-cta";
import { McpServerGuide } from "@/components/mcp-server-guide";
import PublicHeader from "@/components/public-header";
import { SiteFooter } from "@/components/site-footer";

export default function McpDocs() {
  return (
    <>
      <Head title="OG Image MCP Server" />

      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
        <PublicHeader />

        <div className="container mx-auto max-w-4xl px-4 py-12">
          <div className="mb-8 space-y-3">
            <p className="text-sm font-medium text-orange-700 dark:text-orange-300">MCP server</p>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">MCP server for social images</h1>
            <p className="text-gray-600 dark:text-gray-300">
              This is the OG Pilot MCP install guide. Add the remote server, approve OAuth, and ask the agent for the
              first social image. The endpoint is <code>https://ogpilot.com/mcp</code>. Debug, compress, and palette
              work on a guest connector session. <code>generate_og_image</code> needs an active plan. On WordPress,{" "}
              <Link
                href="/change-og-image-wordpress"
                className="font-medium text-orange-700 hover:underline dark:text-orange-300"
              >
                change the OG image
              </Link>{" "}
              with a featured image, an SEO-plugin field, or this tool. The tag names are the{" "}
              <Link
                href="/open-graph-protocol-wordpress"
                className="font-medium text-orange-700 hover:underline dark:text-orange-300"
              >
                Open Graph protocol
              </Link>
              . The plugin lander stays at{" "}
              <Link href="/wordpress" className="font-medium text-orange-700 hover:underline dark:text-orange-300">
                /wordpress
              </Link>
              .
            </p>
            <p className="text-gray-600 dark:text-gray-300">
              Astro sites comparing a static file, a build-time endpoint, and this API:{" "}
              <a href="/astro-og-image" className="font-medium text-orange-700 hover:underline dark:text-orange-300">
                Dynamic OG images for Astro
              </a>
              .
            </p>
          </div>

          <McpServerGuide />
        </div>

        <FinalCta
          title="Generate a social image from a page URL"
          description="Connect the MCP server, or paste the domain below to open the browser generator."
          highlights={[
            { icon: "🔗", text: "Remote server at /mcp" },
            { icon: "🖼️", text: "Generate, debug, compress, palette" },
          ]}
          submitLabel="Open OG Pilot"
          subtext="MCP image generation needs an active plan and a credit."
        />
      </div>
      <SiteFooter />
    </>
  );
}
